export default __webpack_public_path__ + "static/media/04-rules-of-the-road.46d114a4.jpg";